<template>
  <div class="solar-teaser-card" :id="id" :aria-describedby="ariaDescribedBy">
    <div class="image-container">
      <img :src="imageSrc" :alt="imageAlt" class="teaser-image" />
    </div>
    <div class="content-wrapper">
      <h4 class="teaser-headline">{{ headline }}</h4>
      <p class="teaser-text">{{ text }}</p>
      <a :href="buttonLink" target="_blank" class="button button_ghost">{{ buttonText }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SolarTeaserCard',
  props: {
    id: {
      type: String,
      default: null
    },
    ariaDescribedBy: {
      type: String,
      default: null
    },
    imageSrc: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      default: 'Solar Teaser Bild'
    },
    headline: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    buttonLink: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
#app-ves-clickstream .solar-teaser-card {
  text-align: center;
  background-color: var(--input-background-color);
  /*border-radius: 8px;*/
  overflow: hidden;
  /*box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);*/
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: transform 0.2s ease-in-out;
}


#app-ves-clickstream .image-container {
  width: 100%;
  padding-top: 56.25%; /* 16:9 Seitenverhältnis */
  position: relative;
  overflow: hidden;
}

#app-ves-clickstream .teaser-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

#app-ves-clickstream .content-wrapper {
  padding: 25px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

#app-ves-clickstream .teaser-headline {
  font-size: 1.5em;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 15px;
  line-height: 1.2;
  color: #333;
}

#app-ves-clickstream .teaser-text {
  font-size: 1em;
  line-height: 1.6;
  color: #555;
  margin-bottom: 25px;
  flex-grow: 1;
}


#app-ves-clickstream .solar-teaser-card .button_ghost.button {
  padding-left: 20px;
  padding-right: 20px;
  align-self: center;
}
</style>